import { all, put, takeEvery } from "redux-saga/effects";
import { fetcher, getErrorMsg, handleError } from "lib/fetch";
import * as actions from "./actions";

const url = "delivery-distances"

function* loadDistances(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(url, params, token);
    yield put(actions.loadDistances.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.loadDistances.failure(getErrorMsg(error)));
  }
}

function* showDistance(action) {
  try {
    const { id, token } = action.payload;
    const res = yield fetcher.get(`${url}/${id}`, token);
    yield put(actions.showDistance.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.showDistance.failure(getErrorMsg(error)));
  }
}

function* createDistance(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/create`, params, token);
    yield put(actions.createDistance.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.createDistance.failure(getErrorMsg(error)));
  }
}

function* updateDistance(action) {
  try {
    const { params, id, token } = action.payload;
    const res = yield fetcher.post(`${url}/update/${id}`, params, token);
    yield put(actions.updateDistance.success(res.data));
   
  } catch (error) {
    handleError(error);
    yield put(actions.updateDistance.failure(getErrorMsg(error)));
  }
}

function* deleteDistance(action) {
  try {
    const { id, token } = action.payload;
    yield fetcher.get(`${url}/delete/${id}`, token);
    yield put(actions.deleteDistance.success(id));
  } catch (error) {
    handleError(error);
    yield put(actions.deleteDistance.failure(getErrorMsg(error)));
  }
}

function* importDistance(action) {
  try {
    const { file, token } = action.payload;
    const formData = new FormData();
    formData.append("file_name", file.originFileObj);
    const res = yield fetcher.upload(`${url}/import`, formData, token);
    yield put(actions.importDistance.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.importDistance.failure(getErrorMsg(error)));
  }
}

function* exportDistance(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/export`, params, token);
    yield put(actions.exportDistance.success(res.data));
    fetcher.download(res.data.data);
  } catch (error) {
    handleError(error);
    yield put(actions.exportDistance.failure(getErrorMsg(error)));
  }
}

export default function* watchDistance() {
  yield all([
    takeEvery(actions.LOAD_DISTANCE.REQUEST, loadDistances),
    takeEvery(actions.SHOW_DISTANCE.REQUEST, showDistance),
    takeEvery(actions.CREATE_DISTANCE.REQUEST, createDistance),
    takeEvery(actions.UPDATE_DISTANCE.REQUEST, updateDistance),
    takeEvery(actions.DELETE_DISTANCE.REQUEST, deleteDistance),
    takeEvery(actions.IMPORT_DISTANCE.REQUEST, importDistance),
    takeEvery(actions.EXPORT_DISTANCE.REQUEST, exportDistance),
  ]);
}
